import { BotWalletSupportedChain, WalletType } from "./types";

export const resolveBotWalletSwitchChainId = (chain: WalletType) => {
  return chain === WalletType.ETH
    ? BotWalletSupportedChain.ETH
    : BotWalletSupportedChain.SOL;
};
